import { QueryCache, QueryClient, MutationCache } from "@tanstack/react-query"
import useToastNotifications from "utilities/useToastNotifications"
import useErrors from "./useErrors"

const defaultQueryClientOptions = {
  queries: {
    // staleTime: 1000 * 60 * 5, // detaults to 0
    // cacheTime: 900000, // default 5 minutes
    refetchOnMount: false,
    refetchOnReconnect: false,
    // refetchOnWindowFocus: process.env.NODE_ENV === 'production',
    refetchOnWindowFocus: false,
    // retry: process.env.NODE_ENV === 'production' ? 3 : false, // defaults 3
    retry: 3, // defaults 3
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  },
  // mutations: {
  //   onError: (error) => error,
  // },
}

// query client for testing
export const generateQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      ...defaultQueryClientOptions,
      retry: false,
    },
  })
}

const useQueryClient = () => {
  const { openToastNotification, toastContextHolder } = useToastNotifications()
  const { errorHandler } = useErrors({ openToastNotificationOverride: openToastNotification })

  const queryClient = new QueryClient({
    defaultOptions: defaultQueryClientOptions,
    // the QueryCache error handler is only triggered after all retries have failed
    queryCache: new QueryCache({
      onError: (error, query) => {
        const isEnabled = query.queryKey.every((key) => key !== null && key !== undefined && key !== 0)
        if (isEnabled) errorHandler({ error })
        console.log("QueryCache onError", {
          error,
          query,
        })

        return error
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        errorHandler({ error })
        return error
      },
    }),
  })

  return {
    toastContextHolder,
    queryClient,
  }
}

export default useQueryClient
